import React from 'react'
import '../App.css';
function Badge({title}) {
  return (
    <div className='badge'>
        <h4>
            {title}
        </h4>
    </div>
  )
}

export default Badge
